import { notification } from "antd";
import type { NotificationArgsProps } from "antd";
import { useEffect } from "react";
import { useStore } from "../store";
import { observer } from "mobx-react-lite";

const Notification: React.FC = observer(() => {
  const [api, contextHolder] = notification.useNotification();
  const { notificationStore } = useStore();
  const { getNotificationsArray } = notificationStore;

  const openNotification = (props: NotificationArgsProps) => {
    api.info({
      message: props.message || "Info",
      description: props.description || "",
      placement: props.placement || "topRight",
    });
  };

  useEffect(() => {
    getNotificationsArray.forEach((notification: any) => {
      openNotification(notification);
      notificationStore.removeNotification();
    });
    // eslint-disable-next-line
  }, [getNotificationsArray]);

  return contextHolder;
});

export default Notification;
